import React from "react";
import { Growl } from "primereact/growl";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import ServicioHttp from "../servicio/ServicioHttp";
import servicioFormatos from "../servicio/ServicioFormatos";
import ServicioArchivos from "../servicio/ServicioArchivos";

const JOIN_PRINCIPAL = {    
    
};
const PAGINACION_INICIAL = {
    registrosPorPagina: 100,
    join: null,
    restriccionesDinamicas: [
    ],
    ordenamientos:[
        {
            tipo:"asc",
            nombrePropiedad:"fechaExpiracion"
        }
    ]
}

/**
 * Vista estatus de certificados próximos a vencer
 * 
 * @ maritza
 */
export class ExpiracionDeCertificados extends React.Component {

    constructor() {
        super();
        this.state = {
            idsenube:0,
            paginacion:PAGINACION_INICIAL
        };
    }

    componentDidMount() {
        this.consultarCertificados();
    }

    /**
     * Método consultarCertificados --> 
     * Realiza una consulta general a la BD (entidad Empresa),
     * para llenar los datos de la tabla
     */
    consultarCertificados() {
        this.asignarRestricciones();
        let {paginacion}=this.state;
        ServicioHttp.consumirPostHttp("empresa/consultar.json",paginacion).then((response) => {
                this.setState({ paginacion: response.data.objeto });
            }).catch(() => { });
    }

    reporteExcel() {
        this.descargarReporteExcel();
    }

    /**
     * Método descargarReporteExcel -->
     * Metodo que permite generar y descargar un reporte en excel 
     * (acerca del estatus de los certificados)
     */
    descargarReporteExcel = () => {
        ServicioArchivos.descargaArchivo('documentos/excel_expiracion_certificados.json');
    }

    /**
     * Método formatoFecha --> 
     * EStablece el formato de la fecha (YYYY-MM-DD HH:mm:ss)
     * @param {*} rowData 
     * @param {*} column 
     */
    formatoFecha = (rowData, column) => {
        return <div>{servicioFormatos.formatearFecha(rowData.fechaExpiracion)}</div>
    }

    formatoEstadoCertificado(rowData, column) {
        var fechaFinal = rowData.fechaExpiracion;
        var estado = rowData.estado;
        return servicioFormatos.formatoEstadoCertificado(fechaFinal, estado);
    }

    asignarRestricciones = () => {
        let { paginacion } = this.state;
        paginacion.join = JOIN_PRINCIPAL;
        paginacion.restriccionesDinamicas = [];
        this.setState({paginacion:paginacion});       
      }

      cambiaPagina = (event) => {
        let { paginacion } = this.state;
        paginacion.numeroPagina = event.page;
        paginacion.registrosPorPagina = event.rows;
        this.setState({ idsenube: event.first });
        this.buscarPorFechas();
      }

      refrescar = () => {
        this.consultarCertificados();
      }

    render() {
        let { paginacion } = this.state;

        const paginatorLeft = <Button icon="pi pi-refresh" onClick={this.refrescar.bind(this)}/>;

        return (
            <div >
                <Growl ref={(el) => (this.growl = el)} />
                <div className="p-grid">
                    <div className="p-col-12">
                        <div className="card card-w-little">
                            <div className="p-fluid p-grid">
                                <div className="p-col-12 p-md-12">
                                    <h1 >Estatus de certificados próximos a vencer</h1>
                                </div>
                                <div className="p-col-12 p-md-3">
                                    <Button label="Reporte Excel"
                                        icon="pi-md-folder"
                                        onClick={this.reporteExcel.bind(this)}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="card">
                    <DataTable
                        value={paginacion.datos}
                        responsive={true}
                        autoLayout={true}
                        header="Relación de certificados"
                        paginator={true} paginatorLeft={paginatorLeft}
                        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                        rows={10} 
                        rowsPerPageOptions={[10,20,30]}>
                        <Column header="Usuario IDSE" field="usuario" autoLayout={true} style={{ width: '200px' }} />
                        <Column header="Registro Patronal" field="registroPatronal" autoLayout={true} style={{ width: '200px' }} />
                        <Column header="Razón Social" field="razonSocial" autoLayout={true} style={{ width: '200px' }} />
                        <Column header="RFC" field="rfc" autoLayout={true} style={{ width: '200px' }} />
                        <Column header="Fecha de Vencimiento" body={this.formatoFecha.bind(this)} autoLayout={true} style={{ width: '200px' }} />
                        <Column header="Estatus" body={this.formatoEstadoCertificado} autoLayout={true} style={{ width: '200px' }} />
                    </DataTable>
                </div>
            </div>
        );
    }
}